/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkManualChangesRequest
 */
export interface BulkManualChangesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkManualChangesRequest
     */
    documentIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkManualChangesRequest
     */
    recordingIds?: Array<string>;
}

/**
 * Check if a given object implements the BulkManualChangesRequest interface.
 */
export function instanceOfBulkManualChangesRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BulkManualChangesRequestFromJSON(json: any): BulkManualChangesRequest {
    return BulkManualChangesRequestFromJSONTyped(json, false);
}

export function BulkManualChangesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkManualChangesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentIds': !exists(json, 'document_ids') ? undefined : json['document_ids'],
        'recordingIds': !exists(json, 'recording_ids') ? undefined : json['recording_ids'],
    };
}

export function BulkManualChangesRequestToJSON(value?: BulkManualChangesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'document_ids': value.documentIds,
        'recording_ids': value.recordingIds,
    };
}

